import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import QutoLogger from 'quto-logger';
import { Provider } from 'react-redux';
import { store } from './app/store';

const logger = new QutoLogger({
  apiKey: process.env.REACT_APP_QUTO_LOGGER_API_KEY,
  environment: process.env.NODE_ENV || 'production',
});

window.addEventListener('error', (event) => {
  if (event.error) {
    logger.captureException(event.error, { url: window.location.href });
  }
});

window.addEventListener('unhandledrejection', (event) => {
  logger.error('Unhandled promise rejection', {
    reason: String(event.reason),
    url: window.location.href,
  });
});


const root = ReactDOM.createRoot(document.getElementById('root'))

// eslint-disable-next-line react/no-deprecated
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
